import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import AdminPanel from "./AdminPanel";
import {useAuth} from "./hooks/UserAuth";
import {LoginForm} from "./LoginForm";
import {GenresPanel} from "./display/genres/GenresPanel";
import SerialsPanel from "./display/serials/SerialsPanel";
import {MembersPanel} from "./display/members/MembersPanel";
import {EditSerialPanel} from "./create/serials/EditSerialPanel";
import {EditFranchisePanel} from "./create/franchises/EditFranchisePanel";
import FranchisesPanel from "./display/franchises/FranchisesPanel";
import { BroadcastPanel } from "./display/broadcast/BroadcastPanel";

export function UserApp(props) {
    const auth = useAuth();

    return (
        auth.user ?
            <Router>
                <Routes>
                    <Route path="/" element={<AdminPanel user={auth.user}/>}/>
                    <Route path="/serials" element={<SerialsPanel user={auth.user}/>}/>
                    <Route path="/serials/edit" element={<EditSerialPanel user={auth.user}/>}/>
                    <Route path="/genres" element={<GenresPanel user={auth.user}/>}/>
                    <Route path="/members" element={<MembersPanel user={auth.user}/>}/>
                    <Route path="/franchises" element={<FranchisesPanel user={auth.user}/>}/>
                    <Route path="/franchises/edit" element={<EditFranchisePanel user={auth.user}/>}/>
                    <Route path="/broadcast" element={<BroadcastPanel user={auth.user}/>}/>
                </Routes>
            </Router>
            :
            <LoginForm/>
    );
}